module.exports = __webpack_public_path__ + "static/media/PortfolioTemplate.5df32c18.png";